exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conf-us-text{\r\n    background-color: #fff;\r\n    top: -97px;\r\n    text-align: justify;\r\n    padding: 40px 30px;\r\n}\r\n\r\n@media only screen and (max-width: 768px){\r\n    .conf-us-text {\r\n        top: -40px;\r\n    }\r\n    .confidentiality {\r\n        position: relative;\r\n        top: 52px;\r\n    }\r\n    \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/confidentiality/confidentiality.component.css
// module id = ../../../../../src/app/confidentiality/confidentiality.component.css
// module chunks = main